import { useRef } from 'react';
import { useDispatch } from 'react-redux';

import { closeModal } from 'reducers/modalReducer';

import './StandardModal.css';

const StandardModal = (props) => {
	const dispatch = useDispatch();
	const modalRef = useRef(null);
	const {
		children,
		title,
		subtitle,
		onConfirm,
		confirmText,
		className,
		size,
		closeOnOutsideClick,
		footerButtons,
		closeLabel,
		closeBtnClass,
		disableConfirm,
		disableClose,
		confirmColor,
		noFooter,
		noFooterClose,
		isLoading = false,
	} = props;

	const onClose = () => {
		// Call any additional close logic here
		if (props.onClose) {
			props.onClose();
		}
		// Close the modal via Redux
		dispatch(closeModal());
	};

	// Every StandardModal gets the v3 look: the frame from StandardModal.css ("v3-modal") and
	// themed Bootstrap content from styles/v3Scope.css ("v3-scope"). Modals that already opt in
	// through violerts-v3-root style themselves, so they're left alone.
	const themeClass = className?.includes('violerts-v3-root') ? '' : 'v3-modal v3-scope';

	let dialogClass = 'modal-dialog';

	if (
		size === 'sm' ||
		size === 'lg' ||
		size === 'xl' ||
		size === 'max' ||
		size === 'fullscreen'
	) {
		dialogClass = `modal-dialog modal-${size}`;
	}

	const handleOutsideClick = (event) => {
		if (closeOnOutsideClick && event.target === modalRef.current) {
			//if the user clicks on the overlay outside the modal dialog, close the modal
			onClose();
		}
	};

	return (
		<div
			className={`modal ${themeClass} ${className || ''}`}
			tabIndex="-1"
			ref={modalRef}
			role="dialog"
			onClick={handleOutsideClick}
		>
			<div className={dialogClass} role="document">
				<div className="modal-content">
					<div className="modal-header">
						<div className="modal-header-titles">
							<h5 className="modal-title">{title}</h5>
							{subtitle && <div className="modal-subtitle">{subtitle}</div>}
						</div>
						<button
							type="button"
							className="close"
							onClick={onClose}
							aria-label="Close"
						>
							<span aria-hidden="true">
								<i className="bi bi-x-lg" />
							</span>
						</button>
					</div>
					<div className="modal-body">{children}</div>
					{!noFooter && (
						<div className="modal-footer">
							{!noFooterClose && (
								<button
									type="button"
									className={closeBtnClass || 'btn btn-secondary'}
									disabled={disableClose === true}
									onClick={() => {
										if (props?.onCancel) {
											props.onCancel();
											dispatch(closeModal());
										} else {
											onClose();
										}
									}}
								>
									{closeLabel || 'Close'}
								</button>
							)}
							{onConfirm && confirmText && (
								<button
									type="button"
									className={`btn btn-${confirmColor || 'primary'}`}
									disabled={disableConfirm === true || isLoading}
									onClick={() => onConfirm()}
								>
									{confirmText}
									{isLoading && (
										<span
											className="spinner-border spinner-border-sm ml-2"
											role="status"
											aria-hidden="true"
										></span>
									)}
								</button>
							)}
							{footerButtons}
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default StandardModal;
